// extracted by mini-css-extract-plugin
module.exports = {"addPost":"index_addPost_3U8JB","label":"index_label_2uDYk","submit":"index_submit_3gcRO","editor":"index_editor_2Puad"};